<h2 mat-dialog-title>{{title}}</h2>
<mat-dialog-content class="mat-typography">
  <div class="dialog-text" [innerHtml]="body | safe: 'html'"></div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button *ngIf="closeBtnName" mat-button [mat-dialog-close]="false">{{closeBtnName}}</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>{{okBtnName}}</button>
</mat-dialog-actions>
